var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFC7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4.01831V2.5H11.5V4.02002C7.89355 4.31177 6 7.77295 6 12C6 16.2422 7.58252 19.7131 11.5 19.9832V21.5H12.5V19.9832C16.4175 19.7131 18 16.2422 18 12C18 7.76538 16.2559 4.29907 12.5 4.01831ZM11.5 5.68774C7.47656 6.09473 8.06494 10.5342 10.7505 10.9819C10.9937 11.0225 11.2446 11.0659 11.5 11.1133V5.68774ZM12.5 11.3191V5.67285C16.1636 5.95972 16.875 10.3472 16.5913 13.4382C15.7661 12.2947 14.1294 11.6941 12.5 11.3191ZM11.5 12.8652C9.90527 12.4888 8.3208 11.8896 7.5127 10.7705C7.23145 13.832 7.92676 18.1655 11.5 18.5266V12.8652ZM12.5 18.5305V13.0759C12.7915 13.1311 13.0781 13.1809 13.354 13.2268C16.0625 13.6782 16.6377 18.1899 12.5 18.5305Z",
    fill: "#0D0543"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdo);
export default __webpack_public_path__ + "static/media/usdo.cad7e71b5a99f02c6b6b3707679d868c.svg";
export { ForwardRef as ReactComponent };